<template>
    <v-card flat>
        <v-card-actions>
        <div style="width:100%; background-color: rgb(240,240,240)">
            <draggable v-model="selectedVar" group="a">
                <v-chip v-if="selectedVar.length==0">Drag to Add Lines to Plot</v-chip>
                <v-chip close v-for="(j, index) in selectedVar"
                        @input="removeSelection(index)"
                        label
                >
                    {{j.equipment_name}} - {{j.name}}
                </v-chip>

            </draggable>
        </div>
        </v-card-actions>
        <v-card-text class="padded-card">
        <multi-plot-chart
                :on-only="onOnly"
                :date-range="dateRange"
                :variables-list="selectedVar"
                :layout-overrides="layout"
                disable-responsive
                just-plot
                type="scattergl"
        ></multi-plot-chart>
        </v-card-text>
    </v-card>
</template>

<script>
  import draggable from 'vuedraggable'
  import MultiPlotChart from '../MultiPlotChart'

  export default {
    methods: {
      removeSelection (index) {
        this.selectedVar.splice(index,1)
      }
    },
    props: {
      onOnly: {type: Boolean, default: false},
      dateRange: {type: Object, default: null}
    },
    name: 'PlotAndSelector',
    components: {
      MultiPlotChart,
      draggable
    },
    data () {
      return {
        selectedVar: [],
          layout:{
              legend: {
                  orientation: 'h',
                  y:-0.3
              },
          }
      }
    },

  }
</script>

<style scoped>
.padded-card{
    padding: 9px;
}
</style>
